<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import usei18n from '@/lib/i18n'

import CmkMultitoneIcon from '@/components/CmkIcon/CmkMultitoneIcon.vue'
import CmkHeading from '@/components/typography/CmkHeading.vue'
import CmkParagraph from '@/components/typography/CmkParagraph.vue'

const { _t } = usei18n()
</script>

<template>
  <div class="ai-assistant-welcome-banner">
    <div class="ai-assistant-welcome-banner__badge">
      <CmkMultitoneIcon
        class="ai-assistant-welcome-banner__icon"
        name="sparkle"
        :primary-color="{ custom: 'var(--white)' }"
      />
    </div>
    <CmkHeading type="h1">
      {{ _t('Welcome to') }}
      <span class="ai-assistant-welcome-banner__product">{{ _t('Checkmk Assistant') }}</span>
    </CmkHeading>
    <CmkParagraph class="ai-assistant-welcome-banner__intro">
      {{ _t('An AI assistant that helps you dive into your data and investigate') }}
    </CmkParagraph>
  </div>
</template>

<style scoped>
.ai-assistant-welcome-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ai-assistant-welcome-banner__badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin-bottom: var(--dimension-8);
  border-radius: 50%;
  background: linear-gradient(221deg, var(--color-purple-50) 46%, var(--color-dark-blue-50) 92%);
}

.ai-assistant-welcome-banner__icon {
  width: 56px;
  height: 56px;
  margin-right: 6px;
}

.ai-assistant-welcome-banner__product {
  color: var(--font-color-accent);
}

.ai-assistant-welcome-banner__intro {
  margin: var(--dimension-4) 0 var(--dimension-10);
  font-size: var(--font-size-large);
  line-height: var(--dimension-8);
  color: var(--font-color-strong);
}
</style>
